import { FC } from "react";
import { Modal } from "@app/shared/Modals";
import SpecialtyGroupExceptionsService from "@app/projects/specialtyGroupExceptionsService";
import { toast } from "react-toastify";

interface ProcessExceptionsModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  onSuccess?: () => void;
}

const ProcessExceptionsModal: FC<ProcessExceptionsModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  onSuccess,
}) => {
  const specialtyGroupExceptionsService = new SpecialtyGroupExceptionsService();

  const ProcessExceptions = () => {
    specialtyGroupExceptionsService.bulkProcessUnprocessedSpecialtyGroupExceptions()
      .then(() => {
        //200 status
        toast("Exceptions have been successfully submitted for processing!", {
          containerId: "z-index-9999",
          type: "success",
        });

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch(() => {
        // 500 error
        toast.error("An error occurred while processing exceptions. Please try again.", {
          containerId: "z-index-9999",
        });
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  }

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      closeModal={closeModal}
      content={{
        body: (
          <div className="pl-3 pr-3 mb-3">
            Are you sure you want to process ALL unprocessed Specialty group exceptions?
          </div>
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: ProcessExceptions,
        confirmButtonText: "Continue",
        confirmButtonType: "primary",
        title: "Process Exceptions",
      }}
      isVisible={isModalOpen}
      hideBodyScroll={true}
    />
  );
};

export default ProcessExceptionsModal;